<template>
  <div>
    <div class="column items-center header">
      <combined-logo/>
      <div class="r-stretch animation">
        <lottie-player
          :src="JSON.stringify(require('@/assets/animations/confetti.json'))"
          loop
          autoplay/>
        <div class="confetti-text column items-center text-riseup-blue r-image-headline">
          <div>{{ firstName }},</div>
          <div>עשית את זה!</div>
        </div>
      </div>
    </div>

    <div class="r-text-intro">מה עכשיו?</div>
    <div class="r-text-headline-paragraph">
      <div>זה לוקח קצת יותר משבוע עד שהקופה נפתחת ב׳מיטב׳.</div>
      <div>תיכף יגיע מייל עם כל הפרטים.</div>
    </div>
    <div class="r-text-headline-paragraph">
      <div>בכל בקשה או שאלה -</div>
      <div>אפשר לפנות אלינו:</div>
      <link-button text="saving@riseup.co.il" display="block" @click="sendMailTo('saving@riseup.co.il')"/>
    </div>
    <div class="r-text-intro">אפשר גם...</div>
    <out-of-flow-button text="לשמוח ולשתף שפתחת חיסכון!" icon="share" flip-icon @click="share"/>
    <web-share ref="webShare" :text="shareText" title="לשתף את הלינק" url="https://saving.riseup.co.il" :alternativeAction="shareViaWhatsApp"
               @share-started="shareStarted" @share-done="shareDone" @share-aborted="shareAborted" @share-failed="shareFailed" />
  </div>

</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import { mapState } from 'vuex';
import BaseUI from 'base-ui';
import ScrollToTop from '@/mixins/ScrollToTop';
import CombinedLogo from '@/components/meitav-dash/CombinedLogo';
import LinkButton from '@/components/base/LinkButton';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';
import OutOfFlowButton from '@/components/styled/OutOfFlowButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'Congratulations',
  mixins: [TrackedPage, ScrollToTop, ExternalPagesActions],
  components: {
    OutOfFlowButton,
    LinkButton,
    CombinedLogo,
    WebShare: BaseUI.WebShare,
  },

  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
    shareText() {
      return 'איזה כיף! אני גאה שעשיתי משהו טוב בשביל העתיד שלי 😍 פתחתי עכשיו קופת גמל להשקעה 🎊';
    },
  },
  methods: {
    shareViaWhatsApp() {
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareViaWhatsApp');
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareText)}`, '_blank');
    },
    shareStarted() {
      this.loading = true;
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareStarted');
    },
    shareDone() {
      this.loading = false;
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareDone');
    },
    shareAborted() {
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareAborted');
      this.loading = false;
    },
    shareFailed(event) {
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareFailed');
      DDLogs.error('Failed to share using Web Share API', { errorMessage: event.error });
      this.loading = false;
    },
    async share() {
      Segment.trackUserInteraction('Saving_CongratulationsPage_ShareButtonClicked');
      await this.$refs.webShare.share();
    },
  },
};
</script>

<style scoped lang="scss">

.animation {
  position: relative;
  margin-top: 23px;

  .confetti-text {
    position: absolute;
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.email {
  font-size: 16px;
  text-decoration: underline;
}

.header {
  margin-bottom: 21px;

  .confetti-header {
    margin-top: 16px;
  }
}

</style>
